import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TransferState } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { ApiService, IOrder, TransferableGetApiService } from '@cakeiteasy/web-utils';
import { IOrderStatus } from '../models/i-order-models';

@Injectable()
export class OrdersApiService extends TransferableGetApiService {
  constructor(@Inject('AppConfig') appConfig: any,
              @Inject(PLATFORM_ID) _platformId: any,
              api: ApiService,
              transferState: TransferState) {
    super(api, appConfig, _platformId, transferState);
  }

  public getOrderBySid(sid): Promise<IOrder> {
    return firstValueFrom(this.getWithCaching('api.orders', 'order_one', { orderId: sid }));
  }

  public getOrderStatusBySid(sid: string): Observable<IOrderStatus> {
    return this.api.get('api.payments', 'payment_status', { sid });
  }

  public getOrderBySidWithoutCaching(sid): Promise<IOrder> {
    return firstValueFrom(this.api.get('api.orders', 'order_one', { orderId: sid }));
  }

  public updateDeliveryOrder(orderId: number, data: any): Observable<IOrder> {
    return this.api.patch('api.orders', 'delivery_order', { orderId }, data);
  }

  public getBakeryDeliveryInfo(orderId: number, params: any): Observable<any> {
    return this.api.get('api.orders', 'bakery_delivery_info', { orderId }, { params });
  }
}
